<div
  role="dialog"
  aria-labelledby="modalAddEditContactTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex align-items-center gap-2">
          <i class="ri-time-line text-primary font-22"></i>
          <h5 class="modal-title mb-0 fw-bold">{{ 'attendance.monitoring.configureWaitingAlerts' | translate }}</h5>
        </div>
        <button
          type="button"
          class="btn-close"
          [attr.aria-label]="'attendance.monitoring.close' | translate"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h5 class="mb-0 fw-bold">{{ 'attendance.monitoring.enableAlerts' | translate }}</h5>
          <div class="custom-switch">
            <input
              type="checkbox"
              id="alertsEnabled"
              data-switch="success"
              [(ngModel)]="alertsEnabled"
            />
            <label for="alertsEnabled"></label>
          </div>
        </div>

        <div class="mb-4">
          <h5 class="mb-1 fw-bold">{{ 'attendance.monitoring.timeLimitMinutes' | translate }}</h5>
          <p class="text-muted mb-2">
            {{ 'attendance.monitoring.waitingAttendancesFlagged' | translate }}
          </p>
          <input
            id="delayMinutes"
            type="number"
            class="form-control"
            min="1"
            step="1"
            [(ngModel)]="minutes"
            name="delayMinutes"
            [disabled]="!alertsEnabled"
          />
        </div>

        <!-- Alerta sonoro -->
        <div class="d-flex justify-content-between align-items-center mb-1">
          <div class="me-3">
            <h5 class="mb-0 fw-bold">{{ 'attendance.monitoring.soundAlert' | translate }}</h5>
            <p class="text-muted mb-0">
              {{ 'attendance.monitoring.soundAlertDescription' | translate }}
            </p>
          </div>
          <div class="custom-switch">
            <input
              type="checkbox"
              id="soundAlertEnabled"
              data-switch="success"
              [(ngModel)]="soundAlertEnabled"
              [disabled]="!alertsEnabled"
            />
            <label for="soundAlertEnabled"></label>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-light" (click)="close()">
          {{ 'attendance.monitoring.cancel' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="save()"
          [disabled]="minutes < 1"
        >
          {{ 'attendance.monitoring.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
